import { SlotLine } from "../line_holder_slot";
import { SlotGame } from "../../net/proto/proto_slot_game";
import { SlotRoom } from "../../net/proto/proto_slot_room";
import { SlotCycleEvent } from "./slot_cycle_event";
import ModelData from "../../../public/model_data";
import LoaclStorage from "../../../../manager/local_storage";
import { CountUp } from "../../../../lib/countUp";
import Utility from "../../../../utility/utility";
export enum LineType {
    Box = "-1",
    Single = "0",
    SingleSingleBox = "1",
    BoxSingleSingle = "2",
    BoxSingleBox = "3",
    SingleBox = "4",
    BoxSingle = "5"
}
export enum GridPoint {
    LeftTop = 0,
    RightTop = 1,
    RightBottom = 2,
    LeftBottom = 3,
    TopCenter = 4,
    RightCenter = 5,
    BottomCenter = 6,
    LeftCenter = 7,
    Center = 8
}
export enum SlotFruit {
    SEVEN = "seven",
    DaXiang = "daxiang",
    LiuLian = "liulian",
    HuoLongGuo = "huolongguo",
    BoLuo = "boluo",
    LianWu = "lianwu",
    ShanZhu = "shanzhu",
    MangGuo = "mangguo",
    XiangJiao = "xiangjiao",
    XiGua = "xigua",
    Wild = "wild",
    Free = "FS",
    Bonus = "Bonus"
}

export interface ILineData {
    color: SlotLine
    no: number
    line: number[]
}
export interface ILineBox {
    gridPos: number,
    box: boolean
}
export interface ILineResult {
    win: number,
    starting: number,
    no: number,
    line: ILineBox[],
    color: SlotLine
}
export class SlotGrid {
    icon: cc.Sprite = null
    fuzzyIcon: cc.Sprite = null
    grid: cc.Node = null
    anim: dragonBones.ArmatureDisplay = null
}
export class SlotEx {
    columnList: SlotGrid[] = [new SlotGrid(), new SlotGrid(), new SlotGrid(), new SlotGrid(), new SlotGrid()]
    columnNode: cc.Node = null
    cycleAnim: cc.Animation = null
    freeAnim: cc.Animation = null
    cycleEvent: SlotCycleEvent = null
}
export class SlotData {

    public static instance: SlotData

    public static getInstance(isNew?) {
        if (isNew) {
            this.instance = new SlotData()
            return this.instance
        } else {
            if (!this.instance) {
                this.instance = new SlotData()
                return this.instance
            } else {
                return this.instance
            }
        }
    }

    roomRule

    static roomName
    static gridWidth = 188
    static gridHeight = 188

    static leftEdgeOffset = 21
    static rightEdgeOffset = 23

    static lineHeight = 12

    static baseBigwinCount: number[] = [100, 200, 400]

    static defaultRewardLineList: number[][] = [
        [1, 1, 1, 1, 1], [2, 2, 2, 2, 2], [3, 3, 3, 3, 3], [1, 2, 2, 2, 1], [2, 3, 3, 3, 2], [2, 1, 2, 3, 2], [2, 1, 2, 1, 2], [1, 2, 3, 2, 1], [1, 1, 2, 3, 3], [1, 2, 1, 2, 1],
        [2, 2, 1, 2, 2], [3, 2, 1, 2, 3], [3, 3, 2, 1, 1], [2, 3, 2, 3, 2], [2, 2, 3, 2, 2], [2, 1, 1, 1, 2], [3, 2, 2, 2, 3], [2, 3, 2, 1, 2], [3, 2, 3, 2, 3], [1, 1, 3, 1, 1],
        [3, 3, 1, 3, 3], [1, 3, 3, 3, 1], [3, 1, 1, 1, 3], [3, 1, 2, 3, 1], [3, 2, 1, 1, 2], [3, 2, 1, 1, 1], [2, 3, 1, 3, 2], [1, 3, 2, 1, 3], [1, 2, 3, 3, 2], [1, 1, 2, 2, 3],
        [2, 1, 3, 1, 2], [1, 3, 2, 3, 1], [1, 1, 3, 3, 3], [3, 3, 1, 1, 1], [3, 3, 2, 2, 1], [1, 3, 1, 3, 1], [3, 1, 3, 1, 3], [3, 1, 2, 3, 1], [1, 2, 3, 3, 3], [1, 1, 1, 1, 3],
    ]

    static defaultIconCycleSequence: string[][] = [
        [SlotFruit.XiGua, SlotFruit.BoLuo, SlotFruit.XiangJiao, SlotFruit.LiuLian, SlotFruit.ShanZhu, SlotFruit.DaXiang, SlotFruit.LianWu, SlotFruit.HuoLongGuo, SlotFruit.MangGuo,
        SlotFruit.SEVEN, SlotFruit.ShanZhu, SlotFruit.DaXiang, SlotFruit.LianWu, SlotFruit.HuoLongGuo, SlotFruit.MangGuo, SlotFruit.SEVEN, SlotFruit.XiangJiao, SlotFruit.BoLuo,
        SlotFruit.XiangJiao, SlotFruit.LiuLian],

        [SlotFruit.SEVEN, SlotFruit.XiGua, SlotFruit.BoLuo, SlotFruit.XiangJiao, SlotFruit.LiuLian, SlotFruit.ShanZhu, SlotFruit.DaXiang, SlotFruit.LianWu, SlotFruit.HuoLongGuo,
        SlotFruit.MangGuo, SlotFruit.SEVEN, SlotFruit.ShanZhu, SlotFruit.DaXiang, SlotFruit.LianWu, SlotFruit.HuoLongGuo, SlotFruit.MangGuo, SlotFruit.SEVEN, SlotFruit.XiGua,
        SlotFruit.BoLuo, SlotFruit.XiangJiao],

        [SlotFruit.SEVEN, SlotFruit.XiGua, SlotFruit.BoLuo, SlotFruit.XiangJiao, SlotFruit.LiuLian, SlotFruit.ShanZhu, SlotFruit.DaXiang, SlotFruit.LianWu, SlotFruit.HuoLongGuo,
        SlotFruit.MangGuo, SlotFruit.SEVEN, SlotFruit.ShanZhu, SlotFruit.DaXiang, SlotFruit.LianWu, SlotFruit.HuoLongGuo, SlotFruit.MangGuo, SlotFruit.SEVEN, SlotFruit.XiGua,
        SlotFruit.BoLuo, SlotFruit.XiangJiao],

        [SlotFruit.MangGuo, SlotFruit.SEVEN, SlotFruit.XiGua, SlotFruit.BoLuo, SlotFruit.XiangJiao, SlotFruit.LianWu, SlotFruit.ShanZhu, SlotFruit.DaXiang, SlotFruit.LianWu,
        SlotFruit.HuoLongGuo, SlotFruit.MangGuo, SlotFruit.SEVEN, SlotFruit.ShanZhu, SlotFruit.DaXiang, SlotFruit.LianWu, SlotFruit.HuoLongGuo, SlotFruit.MangGuo, SlotFruit.SEVEN,
        SlotFruit.XiGua, SlotFruit.BoLuo],

        [SlotFruit.MangGuo, SlotFruit.SEVEN, SlotFruit.XiGua, SlotFruit.BoLuo, SlotFruit.XiangJiao, SlotFruit.LianWu, SlotFruit.ShanZhu, SlotFruit.DaXiang, SlotFruit.LianWu,
        SlotFruit.HuoLongGuo, SlotFruit.MangGuo, SlotFruit.SEVEN, SlotFruit.ShanZhu, SlotFruit.DaXiang, SlotFruit.LianWu, SlotFruit.HuoLongGuo, SlotFruit.MangGuo, SlotFruit.SEVEN,
        SlotFruit.XiGua, SlotFruit.BoLuo],
    ]

    defaultLineColorList: SlotLine[] = []

    baseLineList = new Array()

    lightLineList = new Array()

    inCycleLine: boolean = false

    selfPlayer: SlotRoom.RoomInfo.IPlayer

    slotResult: SlotGame.ISlotResult

    currentSlotResult: SlotGame.ISlotResult

    slotEx: SlotEx[] = [new SlotEx(), new SlotEx(), new SlotEx(), new SlotEx(), new SlotEx()]

    startActionScheduleId

    startFreeActionScheduleId

    startFreeEffectColumn

    defaultCycleScheduleId

    curMultiple: number

    payLineCount: number

    win_loss

    last_win_loss: number = 0

    lineCycleSequence: string[][] = []

    freeAutoSpin: boolean = false

    autoSpin: boolean = false

    freeSpinStatus = -1

    carryMoney: number = 0

    ownMoney: number = 0

    ownMoneyRecord: number = 0

    carryMoneyRecord: number = 0

    isFirstGameInfo = true

    reconnectFreeSpin = false

    curSlotIconIndex: number[] = []

    tempSlotIconIndex: number[] = []

    cycleStatus: number = 0

    playAnimStatus: number = 0

    effectSoundId

    spinSoundId

    _bigwinCount: number[] = [100, 200, 400]

    _spinBgSound = 1

    get cycleTime() {
        return this.freeSpinStatus == -1 ? 3 : 2
    }
    get bigwinCount() {
        return this._bigwinCount
    }
    get spinBgSound() {
        let id = this._spinBgSound
        this._spinBgSound = this._spinBgSound >= 3 ? 1 : this._spinBgSound + 1
        return id
    }

    setbigwinCount(beishu: number) {
        for (let i = 0; i < this.bigwinCount.length; i++) {
            this._bigwinCount[i] = SlotData.baseBigwinCount[i] * beishu
        }
    }

    static setLocalRecord(key, value) {
        LoaclStorage.setString(key + "_" + ModelData.instance.roleData.id + "_" + SlotData.roomName, value)
    }

    static getLocalRecord(key, defaultValue) {
        return LoaclStorage.getString(key + "_" + ModelData.instance.roleData.id + "_" + SlotData.roomName, defaultValue)
    }
    static serverSymbolToIcon(symbol) {
        if (symbol == "香蕉") {
            return SlotFruit.XiangJiao
        } else if (symbol == "西瓜") {
            return SlotFruit.XiGua
        } else if (symbol == "芒果") {
            return SlotFruit.MangGuo
        } else if (symbol == "榴莲") {
            return SlotFruit.LiuLian
        } else if (symbol == "火龙果") {
            return SlotFruit.HuoLongGuo
        } else if (symbol == "莲雾") {
            return SlotFruit.LianWu
        } else if (symbol == "菠萝") {
            return SlotFruit.BoLuo
        } else if (symbol == "山竹") {
            return SlotFruit.ShanZhu
        } else if (symbol == "W" || symbol == "Wild") {
            return SlotFruit.Wild
        } else if (symbol == "大象") {
            return SlotFruit.DaXiang
        } else if (symbol == "777") {
            return SlotFruit.SEVEN
        } else if (symbol == "FS" || symbol == "Free") {
            return SlotFruit.Free
        } else {
            return ""
        }
    }
    static rewardFreeSpinTimes(result: SlotGame.ISlotResult) {
        if (result.freeSpin != null && result.freeSpin != undefined) {
            return result.freeSpin.records.length
        } else {
            return 0
        }
    }
    static randonPointRangeNumber(min, max, num) {
        let arr = new Array;
        let gen = new Array
        for (let i = min; i <= max; i++) {
            arr[i] = i;
        }
        arr.sort(function () { return 0.5 - Math.random(); });
        for (let i = 0; i < num; i++) {
            gen[i] = arr[i];
        }
        return gen
    }
    static numberLaberAnim(startValue, endValue, duration, updateCallback, finishCallback?) {
        let countUp = new CountUp(null, endValue, {
            startVal: startValue,
            decimalPlaces: 0,
            duration: duration,
            useEasing: true,
            useGrouping: true,
            smartEasingThreshold: 999,
            smartEasingAmount: 333,
            separator: '',
            decimal: '.',
            prefix: '',
            suffix: ''
        })
        if (!countUp.error) {
            countUp.start(function (n) {
                let num = parseInt(n)
                if(startValue < endValue && num >= Math.floor(endValue)){
                    num = endValue
                }else if(startValue > endValue && num <= Math.ceil(endValue)) {
                    num = endValue
                }
                num = parseFloat(num.toString())
                updateCallback(num)
            }, finishCallback)
        }
    }
    static instantiateNode(node, parent, name?): cc.Node {
        let obj: cc.Node = cc.instantiate(node);
        obj.parent = parent
        obj.x = 0
        obj.y = 0
        obj.angle = 0
        obj.name = name || "clone"
        obj.active = true
        return obj
    }
    slotTestResult: SlotGame.ISlotResult = null

        // {
        //     "windowSymbols": [
        //         {
        //             "symbols": [
        //                 "芒果",
        //                 "莲雾",
        //                 "莲雾",
        //                 "777",
        //                 "西瓜"
        //             ]
        //         },
        //         {
        //             "symbols": [
        //                 "芒果",
        //                 "莲雾",
        //                 "莲雾",
        //                 "榴莲",
        //                 "西瓜"
        //             ]
        //         },
        //         {
        //             "symbols": [
        //                 "莲雾",
        //                 "莲雾",
        //                 "香蕉",
        //                 "榴莲",
        //                 "西瓜"
        //             ]
        //         }
        //     ],
        //     "paylines": [
        //         {
        //             "paylineNo": 12,
        //             "payline": [
        //                 3,
        //                 2,
        //                 1,
        //                 2,
        //                 3
        //             ],
        //             "symbol": "莲雾",
        //             "comboCount": 3,
        //             "winAmount": 70
        //         },
        //         {
        //             "paylineNo": 13,
        //             "payline": [
        //                 3,
        //                 3,
        //                 2,
        //                 1,
        //                 1
        //             ],
        //             "symbol": "莲雾",
        //             "comboCount": 3,
        //             "winAmount": 70
        //         },
        //         {
        //             "paylineNo": 17,
        //             "payline": [
        //                 3,
        //                 2,
        //                 2,
        //                 2,
        //                 3
        //             ],
        //             "symbol": "莲雾",
        //             "comboCount": 3,
        //             "winAmount": 70
        //         },
        //         {
        //             "paylineNo": 21,
        //             "payline": [
        //                 3,
        //                 3,
        //                 1,
        //                 3,
        //                 3
        //             ],
        //             "symbol": "莲雾",
        //             "comboCount": 3,
        //             "winAmount": 70
        //         },
        //         {
        //             "paylineNo": 23,
        //             "payline": [
        //                 3,
        //                 1,
        //                 1,
        //                 1,
        //                 3
        //             ],
        //             "symbol": "莲雾",
        //             "comboCount": 3,
        //             "winAmount": 70
        //         },
        //         {
        //             "paylineNo": 24,
        //             "payline": [
        //                 3,
        //                 1,
        //                 2,
        //                 3,
        //                 1
        //             ],
        //             "symbol": "莲雾",
        //             "comboCount": 3,
        //             "winAmount": 70
        //         },
        //         {
        //             "paylineNo": 25,
        //             "payline": [
        //                 3,
        //                 2,
        //                 1,
        //                 1,
        //                 2
        //             ],
        //             "symbol": "莲雾",
        //             "comboCount": 3,
        //             "winAmount": 70
        //         },
        //         {
        //             "paylineNo": 26,
        //             "payline": [
        //                 3,
        //                 2,
        //                 1,
        //                 1,
        //                 1
        //             ],
        //             "symbol": "莲雾",
        //             "comboCount": 3,
        //             "winAmount": 70
        //         },
        //         {
        //             "paylineNo": 34,
        //             "payline": [
        //                 3,
        //                 3,
        //                 1,
        //                 1,
        //                 1
        //             ],
        //             "symbol": "莲雾",
        //             "comboCount": 3,
        //             "winAmount": 70
        //         },
        //         {
        //             "paylineNo": 35,
        //             "payline": [
        //                 3,
        //                 3,
        //                 2,
        //                 2,
        //                 1
        //             ],
        //             "symbol": "莲雾",
        //             "comboCount": 3,
        //             "winAmount": 70
        //         },
        //         {
        //             "paylineNo": 38,
        //             "payline": [
        //                 3,
        //                 1,
        //                 2,
        //                 1,
        //                 3
        //             ],
        //             "symbol": "莲雾",
        //             "comboCount": 3,
        //             "winAmount": 70
        //         }
        //     ],
        //     "winAmount": 34.4
        // }

    // {
    //     "windowSymbols": [
    //         {
    //             "symbols": [
    //                 "榴莲",
    //                 "W",
    //                 "榴莲",
    //                 "777",
    //                 "火龙果"
    //             ]
    //         },
    //         {
    //             "symbols": [
    //                 "山竹",
    //                 "大象",
    //                 "榴莲",
    //                 "777",
    //                 "火龙果"
    //             ]
    //         },
    //         {
    //             "symbols": [
    //                 "山竹",
    //                 "大象",
    //                 "榴莲",
    //                 "榴莲",
    //                 "火龙果"
    //             ]
    //         }
    //     ],
    //     "paylines": [
    //         {
    //             "paylineNo": 1,
    //             "payline": [
    //                 1,
    //                 1,
    //                 1,
    //                 1,
    //                 1
    //             ],
    //             "symbol": "榴莲",
    //             "comboCount": 3,
    //             "winAmount": 100
    //         },
    //         {
    //             "paylineNo": 9,
    //             "payline": [
    //                 1,
    //                 1,
    //                 2,
    //                 3,
    //                 3
    //             ],
    //             "symbol": "榴莲",
    //             "comboCount": 4,
    //             "winAmount": 500
    //         },
    //         {
    //             "paylineNo": 20,
    //             "payline": [
    //                 1,
    //                 1,
    //                 3,
    //                 1,
    //                 1
    //             ],
    //             "symbol": "榴莲",
    //             "comboCount": 3,
    //             "winAmount": 100
    //         },
    //         {
    //             "paylineNo": 30,
    //             "payline": [
    //                 1,
    //                 1,
    //                 2,
    //                 2,
    //                 3
    //             ],
    //             "symbol": "榴莲",
    //             "comboCount": 3,
    //             "winAmount": 100
    //         },
    //         {
    //             "paylineNo": 33,
    //             "payline": [
    //                 1,
    //                 1,
    //                 3,
    //                 3,
    //                 3
    //             ],
    //             "symbol": "榴莲",
    //             "comboCount": 4,
    //             "winAmount": 500
    //         },
    //         {
    //             "paylineNo": 40,
    //             "payline": [
    //                 1,
    //                 1,
    //                 1,
    //                 1,
    //                 3
    //             ],
    //             "symbol": "榴莲",
    //             "comboCount": 3,
    //             "winAmount": 100
    //         }
    //     ],
    //     "winAmount": 2100
    // }

    // {
    //     "windowSymbols": [
    //         {
    //             "symbols": [
    //                 "山竹", "FS", "777", "香蕉", "西瓜"
    //             ]
    //         },
    //         {
    //             "symbols": [
    //                 "山竹",
    //                 "大象",
    //                 "777",
    //                 "FS",
    //                 "西瓜"
    //             ]
    //         },
    //         {
    //             "symbols": [
    //                 "FS",
    //                 "大象",
    //                 "777",
    //                 "菠萝",
    //                 "榴莲"
    //             ]
    //         }
    //     ],
    //     "freeSpin": {
    //         "comboCount": 3,
    //         "winAmount": 8880,
    //         "records": [
    //             {
    //                 "windowSymbols": [
    //                     {
    //                         "symbols": [
    //                             "榴莲",
    //                             "莲雾",
    //                             "山竹",
    //                             "山竹",
    //                             "菠萝"
    //                         ]
    //                     },
    //                     {
    //                         "symbols": [
    //                             "山竹",
    //                             "莲雾",
    //                             "W",
    //                             "山竹",
    //                             "菠萝"
    //                         ]
    //                     },
    //                     {
    //                         "symbols": [
    //                             "山竹",
    //                             "莲雾",
    //                             "菠萝",
    //                             "山竹",
    //                             "山竹"
    //                         ]
    //                     }
    //                 ],

    //                 "winAmount": 0
    //             },
    //             {
    //                 "windowSymbols": [
    //                     {
    //                         "symbols": [
    //                             "山竹",
    //                             "莲雾",
    //                             "W",
    //                             "菠萝",
    //                             "山竹"
    //                         ]
    //                     },
    //                     {
    //                         "symbols": [
    //                             "西瓜",
    //                             "W",
    //                             "山竹",
    //                             "山竹",
    //                             "山竹"
    //                         ]
    //                     },
    //                     {
    //                         "symbols": [
    //                             "西瓜",
    //                             "香蕉",
    //                             "山竹",
    //                             "山竹",
    //                             "山竹"
    //                         ]
    //                     }
    //                 ],

    //                 "winAmount": 0
    //             },
    //             {
    //                 "windowSymbols": [
    //                     {
    //                         "symbols": [
    //                             "莲雾",
    //                             "山竹",
    //                             "777",
    //                             "菠萝",
    //                             "芒果"
    //                         ]
    //                     },
    //                     {
    //                         "symbols": [
    //                             "莲雾",
    //                             "W",
    //                             "777",
    //                             "菠萝",
    //                             "芒果"
    //                         ]
    //                     },
    //                     {
    //                         "symbols": [
    //                             "芒果",
    //                             "榴莲",
    //                             "莲雾",
    //                             "山竹",
    //                             "芒果"
    //                         ]
    //                     }
    //                 ],

    //                 "winAmount": 0
    //             },
    //             {
    //                 "windowSymbols": [
    //                     {
    //                         "symbols": [
    //                             "山竹",
    //                             "西瓜",
    //                             "火龙果",
    //                             "山竹",
    //                             "莲雾"
    //                         ]
    //                     },
    //                     {
    //                         "symbols": [
    //                             "西瓜",
    //                             "菠萝",
    //                             "榴莲",
    //                             "山竹",
    //                             "香蕉"
    //                         ]
    //                     },
    //                     {
    //                         "symbols": [
    //                             "西瓜",
    //                             "菠萝",
    //                             "榴莲",
    //                             "W",
    //                             "香蕉"
    //                         ]
    //                     }
    //                 ]
    //             },
    //             {
    //                 "windowSymbols": [
    //                     {
    //                         "symbols": [
    //                             "芒果",
    //                             "香蕉",
    //                             "香蕉",
    //                             "西瓜",
    //                             "大象"
    //                         ]
    //                     },
    //                     {
    //                         "symbols": [
    //                             "芒果",
    //                             "香蕉",
    //                             "西瓜",
    //                             "西瓜",
    //                             "大象"
    //                         ]
    //                     },
    //                     {
    //                         "symbols": [
    //                             "菠萝",
    //                             "香蕉",
    //                             "西瓜",
    //                             "西瓜",
    //                             "西瓜"
    //                         ]
    //                     }
    //                 ],

    //                 "winAmount": 0
    //             },
    //             {
    //                 "windowSymbols": [
    //                     {
    //                         "symbols": [
    //                             "西瓜",
    //                             "莲雾",
    //                             "榴莲",
    //                             "777",
    //                             "山竹"
    //                         ]
    //                     },
    //                     {
    //                         "symbols": [
    //                             "西瓜",
    //                             "莲雾",
    //                             "榴莲",
    //                             "777",
    //                             "山竹"
    //                         ]
    //                     },
    //                     {
    //                         "symbols": [
    //                             "西瓜",
    //                             "莲雾",
    //                             "榴莲",
    //                             "777",
    //                             "榴莲"
    //                         ]
    //                     }
    //                 ]
    //             },
    //             {
    //                 "windowSymbols": [
    //                     {
    //                         "symbols": [
    //                             "火龙果",
    //                             "芒果",
    //                             "大象",
    //                             "西瓜",
    //                             "火龙果"
    //                         ]
    //                     },
    //                     {
    //                         "symbols": [
    //                             "榴莲",
    //                             "芒果",
    //                             "西瓜",
    //                             "西瓜",
    //                             "火龙果"
    //                         ]
    //                     },
    //                     {
    //                         "symbols": [
    //                             "榴莲",
    //                             "芒果",
    //                             "西瓜",
    //                             "莲雾",
    //                             "火龙果"
    //                         ]
    //                     }
    //                 ]
    //             },
    //             {
    //                 "windowSymbols": [
    //                     {
    //                         "symbols": [
    //                             "香蕉",
    //                             "莲雾",
    //                             "芒果",
    //                             "香蕉",
    //                             "大象"
    //                         ]
    //                     },
    //                     {
    //                         "symbols": [
    //                             "香蕉",
    //                             "芒果",
    //                             "香蕉",
    //                             "西瓜",
    //                             "大象"
    //                         ]
    //                     },
    //                     {
    //                         "symbols": [
    //                             "香蕉",
    //                             "芒果",
    //                             "香蕉",
    //                             "西瓜",
    //                             "大象"
    //                         ]
    //                     }
    //                 ]
    //             },
    //             {
    //                 "windowSymbols": [
    //                     {
    //                         "symbols": [
    //                             "火龙果",
    //                             "榴莲",
    //                             "香蕉",
    //                             "W",
    //                             "777"
    //                         ]
    //                     },
    //                     {
    //                         "symbols": [
    //                             "火龙果",
    //                             "香蕉",
    //                             "香蕉",
    //                             "西瓜",
    //                             "莲雾"
    //                         ]
    //                     },
    //                     {
    //                         "symbols": [
    //                             "火龙果",
    //                             "香蕉",
    //                             "香蕉",
    //                             "西瓜",
    //                             "莲雾"
    //                         ]
    //                     }
    //                 ]
    //             },
    //             {
    //                 "windowSymbols": [
    //                     {
    //                         "symbols": [
    //                             "菠萝",
    //                             "山竹",
    //                             "莲雾",
    //                             "香蕉",
    //                             "山竹"
    //                         ]
    //                     },
    //                     {
    //                         "symbols": [
    //                             "菠萝",
    //                             "山竹",
    //                             "菠萝",
    //                             "香蕉",
    //                             "山竹"
    //                         ]
    //                     },
    //                     {
    //                         "symbols": [
    //                             "菠萝",
    //                             "W",
    //                             "菠萝",
    //                             "香蕉",
    //                             "火龙果"
    //                         ]
    //                     }
    //                 ],

    //                 "winAmount": 0
    //             }
    //         ]
    //     }
    // }
}
